import adminModuleMutations from "./adminModule/mutations";
import subscription from "./subscription/mutations";

export default {
  ...adminModuleMutations,
  ...subscription,
};
